import React, { useState, useEffect } from 'react'
import Stats from '../Stats/Stats'
import LogisticTable from './DnDTable/LogisticTable/LogisticTable'
import Filters from './Filters/Filters'
import { mainApi } from '../../store/services/mainApi'
import RouteBoard from './Routes/RouteBoard'
import GoogleMapView from './Map/Map'

export const Logistic = () => {
  const statsMock = [
    {
      item: 'Orders',
      value: '0',
      image: '',
      color: '#F1C52B',
    },
    {
      item: 'Orders',
      value: '0',
      image: '',
      color: '#F1C52B',
    },
    {
      item: 'Orders',
      value: '0',
      image: '',
      color: '#F1C52B',
    },
    {
      item: 'Orders',
      value: '0',
      image: '',
      color: '#F1C52B',
    },
    {
      item: 'Orders',
      value: '0',
      image: '',
      color: '#F1C52B',
    },
    {
      item: 'Orders',
      value: '0',
      image: '',
      color: '#F1C52B',
    },
  ]

  const [logisticOrders, setLogisticOrders] = useState([])
  const { data: logisticOrdersData } = mainApi.useGetLogisticQuery({
    limit: 50,
  })

  useEffect(() => {
    if (logisticOrdersData) {
      setLogisticOrders(logisticOrdersData)
    }
  }, [logisticOrdersData])

  const [selectedPage, setSelectedPage] = useState('List')

  // Разделение заказов на распределённые и нераспределённые
  const assignedOrders = logisticOrders.filter((order) => order.logistic)
  const unassignedOrders = logisticOrders.filter((order) => !order.logistic)

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        // alignItems: 'center',
        // justifyContent: 'center',
        width: '95%',
        margin: '0 auto',
      }}
    >
      <Stats mock={statsMock} />
      <Filters orders={logisticOrders} selectedPage={selectedPage} setSelectedPage={setSelectedPage} />
      {selectedPage === 'List' && <LogisticTable unassignedOrders={unassignedOrders} assignedOrders={assignedOrders} />}
      {selectedPage === 'Routes' && <RouteBoard />}
      {selectedPage === 'Map' && <GoogleMapView />}
    </div>
  )
}
